<template>
  <div>
    <Tabs value="name1">
      <TabPane label="VR安全体验区" name="name1">
        <Row justify="start" type="flex">
          <Col
            class="buy_col01"
            v-for="(item, index) in photoArr1"
            :key="index"
          >
            <div class="buy_rule" @click="getMoney(item)">
              <img :src="item.photoUrl" alt="#" />
            </div>
            <div @click="getMoney(item)" class="sp">{{ item.ref }}</div>
            <div style="font-size: 18px; color: #f12344; margin-bottom: 6px">
              <Button type="primary" @click="getMoney(item)">了解更多</Button>
            </div>
          </Col>
        </Row>
      </TabPane>
      <TabPane label="建筑工程体验馆" name="name2">
        <Experience></Experience>
      </TabPane>
    </Tabs>

    <!--对话框-->
    <div>
      <Modal
        class="modal_div"
        v-model="modal1"
        :title="ref"
        width="80%"
        class-name="vertical-center-modal"
        @on-visible-change="onChange"
      >
        <div slot="header">
          <Row>
            <Col span="20">
              <span class="header_div">{{ this.ref }}</span>
            </Col>
            <Col span="3"> </Col>
          </Row>
        </div>
        <div style="width: 80%; margin: 0 auto">
          <p class="font_size">{{ profile }}</p>
          <img :src="VRImg" alt="暂无照片" />
        </div>
        <div slot="footer">
          <Button @click="modal1 = false">取消</Button>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
import Experience from "./Experience.vue";
export default {
  components: {
    Experience,
  },
  data() {
    return {
      modal1: false,
      item01: [],
      ref: "",
      profile: "",
      VRImg: "",
      photoArr1: [
        {
          photoUrl: "../../../static/img/photo/photo_3d.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_3d.jpg",
          p:
            "使用VR技术身临其境公共安全体验火灾的危险环境，VR系统提醒进行拨打电话、关闭电闸、使用灭火器扑灭拦路的火源等演练" +
            "找寻安全出口逃离火灾，提高火灾突发时的逃生技能",
          VRImg: "../../../static/img/photo-da/photo_3d.jpg",
          ref: "3D视频动画定制教育软件",
          money: "¥500.00-￥4000.00",
          classify: [
            {
              type: "全套共（8）大场景  白色",
              money: "￥4000.00",
              img: "../../../static/img/photo-da/photo_3d.jpg",
            },
            {
              type: "单项软件  白色",
              money: "￥500.00",
              img: "../../../static/img/photo-da/photo_3d.jpg",
            },
          ],
          title: "VR安全体验馆",
          belong: "3D视频动画定制教育软件",
          path: "/home/Buy/VR",
        },
        {
          photoUrl: "../../../static/img/photo/photo_quake.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_quake.jpg",
          p:
            "学进入交互式场景体验，通过系统提醒进行拨打电话、关闭电闸、使用灭火器扑灭拦路的火源等演练" +
            "找寻安全出口逃离火灾，提高学生在火灾突发时的逃生技能",
          VRImg: "../../../static/img/photo-da/photo_quake.jpg",
          ref: "VR地震事故体验定制软件",
          money: "¥500.00-￥2000.00",
          classify: [
            {
              type: "全套共（4）大场景 白色",
              money: "￥2000.00",
              img: "../../../static/img/photo-da/photo_quake.jpg",
            },
            {
              type: "单项软件 白色",
              money: "￥500.00",
              img: "../../../static/img/photo-da/photo_quake.jpg",
            },
          ],
          title: "VR安全体验馆",
          belong: "VR地震事故体验定制软件",
          path: "/home/Buy/VR",
        },
        {
          photoUrl: "../../../static/img/photo/photo_traffic.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_traffic.jpg",
          p:
            "学校是培养二十一世纪人才的摇篮，学生是祖国的未来和民族的希望；由于社会各界十分重视学校的安全工作，安全事故的发生率也在明显的下降，、" +
            "但是安全事故还时有发生，很大一部分原因与小学生的活动精力旺盛和自我保护能力有限有关。VR校园安全体验系统的出现，大大增强了师生安全意识，让学生“亲身”体验安全事故的场景，从而增强人身保护意识，减少悲剧的发生。",
          VRImg: "../../../static/img/photo-da/photo_traffic.jpg",
          ref: "VR校园事故安全体验馆动画定制",
          money: "¥300.00-￥7400.00",
          classify: [
            {
              type: "全套共（26）项  白色",
              money: "￥7400.00",
              img: "../../../static/img/photo-da/photo_traffic.jpg",
            },
            {
              type: "单项软件 白色",
              money: "￥300.00",
              img: "../../../static/img/photo-da/photo_traffic.jpg",
            },
          ],
          title: "VR安全体验馆",
          belong: "VR校园事故安全体验馆动画定制",
          path: "/home/Buy/VR",
        },
        {
          photoUrl: "../../../static/img/photo/photo_electric.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_electric.jpg",
          p:
            "通过VR表现，整个工程逼真的展现在眼前，体验者可以在虚拟中身临其境感受到施工过程中的各种危险和伤害，提高施工人员的安全" +
            "课程培训的兴趣和积极性",
          VRImg: "../../../static/img/photo-da/photo_electric.jpg",
          ref: "VR房建事故体验馆定制教育软件",
          money: "￥300.00-￥8000.00",
          classify: [
            {
              type: "全套共（27）项  白色",
              money: "￥8000.00",
              img: "../../../static/img/photo-da/photo_electric.jpg",
            },
            {
              type: "单项软件 白色",
              money: "￥300.00",
              img: "../../../static/img/photo-da/photo_electric.jpg",
            },
          ],
          title: "VR安全体验馆",
          belong: "VR房建事故体验馆定制教育软件",
          path: "/home/Buy/VR",
        },
        {
          photoUrl: "../../../static/img/photo/photo_student.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_student.jpg",
          ref: "学校款VR消防安全普及推广体验",
          p:
            "相对于我们的标准版VR消防安全知识普及而言，南秀学校定制版VR消防安全更具有对学生的针对性，抓住青少年及未进入社会的学生视角的痛点， " +
            "南秀科技在学校定制版安全普及中加入关于校园霸凌问题、青少年性侵、针对学生的校园诈骗校园传销和暑期青少年溺水等时下尚未得到良好解决办法的社会关注的问题。",
          VRImg: "../../../static/img/AboutUs/School/School01.jpg",
          money: "¥5000.00",
          classify: [
            {
              type: "",
              money: "¥5000.00",
              img: "../../../static/img/photo-da/photo_student.jpg",
            },
          ],
          title: "VR安全体验馆",
          belong: "学校款VR消防安全普及推广体验",
          path: "/home/Buy/VR",
        },
        {
          photoUrl: "../../../static/img/photo/photo_subway.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_subway.jpg",
          p:
            "地铁工程VR体验系统，结合配套VR设备，打造一个真实的建筑工程实训场地，" +
            "解决传统实训过程中，实训难、危险性高材料消耗大、时间周期长等一系列难点。",
          VRImg: "../../../static/img/photo-da/photo_subway.jpg",
          ref: "起重机伤害VR虚拟体验",
          money: "¥500.00",
          classify: [
            {
              type: "",
              money: "￥500.00",
              img: "../../../static/img/photo-da/photo_subway.jpg",
            },
          ],
          title: "VR安全体验馆",
          belong: "起重机伤害VR虚拟体验",
          path: "/home/Buy/VR",
        },
        {
          photoUrl: "../../../static/img/photo/photo_fire.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_fire.jpg",
          p:
            "地铁工程VR体验系统，结合配套VR设备，打造一个真实的建筑工程实训场地，" +
            "解决传统实训过程中，实训难、危险性高材料消耗大、时间周期长等一系列难点。" +
            "使用VR技术身临其境公共安全体验火灾的危险环境，VR系统提醒进行拨打电话、关闭电闸、使用灭火器扑灭拦路的火源等演练" +
            "找寻安全出口逃离火灾，提高火灾突发时的逃生技能",
          VRImg: "../../../static/img/photo-da/photo_fire.jpg",
          ref: "火灾伤害VR虚拟体验",
          money: "¥500.00",
          classify: [
            {
              type: "",
              money: "¥500.00",
              img: "../../../static/img/photo-da/photo_fire.jpg",
            },
          ],
          title: "VR安全体验馆",
          belong: "火灾伤害VR虚拟体验",
          path: "/home/Buy/VR",
        },
        {
          photoUrl: "../../../static/img/photo/photo_first-aid.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_first-aid.jpg",
          p:
            "地铁工程VR体验系统，结合配套VR设备，打造一个真实的建筑工程实训场地，" +
            "解决传统实训过程中，实训难、危险性高材料消耗大、时间周期长等一系列难点。" +
            "使用VR技术身临其境的体验现场急救的VR虚拟体验，针对正常施工现场人员心脏骤停(如触电、高空作业、心脏疾病、" +
            "心肌梗塞、自然灾害、意外事故等所造成的心脏骤停)等紧急情况，现场体验如何进行气道开放、胸外按压、人工口鼻呼吸、体外除颤等抢救过程，" +
            "使病人在短时间内得到救护。",
          VRImg: "../../../static/img/photo-da/photo_first-aid.jpg",
          ref: "现场急救VR虚拟体验",
          money: "¥500.00",
          classify: [
            {
              type: "",
              money: "¥500.00",
              img: "../../../static/img/photo-da/photo_first-aid.jpg",
            },
          ],
          title: "VR安全体验馆",
          belong: "现场急救VR虚拟体验",
          path: "/home/Buy/VR",
        },
        {
          photoUrl: "../../../static/img/photo/photo_drop.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_drop.jpg",
          p:
            "生产生活中，尽管采取了各种防范措施，但人身事故仍时有发生，不仅影响到生产生活的正常进行，也带来企业品牌及社会的负面效应，" +
            "同时给当事人及家庭带来沉重的灾难，影响社会团结稳定。\n" +
            "通过VR仿真模拟，让员工身临其境感受事故发生经过，从而在内心深处对事故产生敬畏心理，树立安全第一的思想意识。",
          VRImg: "../../../static/img/photo-da/photo_drop.jpg",
          ref: "施工电梯坠落事故VR虚拟体验",
          money: "¥300.00",
          classify: [
            {
              type: "",
              money: "￥300.00",
              img: "../../../static/img/photo-da/photo_drop.jpg",
            },
          ],
          title: "VR安全体验馆",
          belong: "施工电梯坠落事故VR虚拟体验",
          path: "/home/Buy/VR",
        },
        {
          photoUrl: "../../../static/img/photo/photo_slip.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_slip.jpg",
          p:
            "相比于传统的工地体验区，VR技术下的虚拟VR体验馆更具有优势：VR安全体验区比实体体验区能够展现更多的体验场景，比如从几十层高的洞口坠落、高空安全带错误使用导致坠落的场景等，同时，VR 场景更加真实完整，体验感更强，安全教育效果更明显。\n" +
            "通过模拟工地建筑施工中的洞口、电梯井等真实场景，开口处维护缺失，工人带上VR眼睛，从视觉上体验从上百米的高度做自由落体运动；同时可以模拟安全带正确使用，高出坠落时身体悬挂在空中等事故。",
          VRImg: "../../../static/img/photo-da/photo_slip.jpg",
          ref: "临边失足坠落事故VR虚拟体验",
          money: "¥500.00",
          classify: [
            {
              type: "",
              money: "￥500.00",
              img: "../../../static/img/photo-da/photo_slip.jpg",
            },
          ],
          title: "VR安全体验馆",
          belong: "临边失足坠落事故VR虚拟体验",
          path: "/home/Buy/VR",
        },
      ],
    };
  },

  methods: {
    onChange() {
      document
        .querySelector("body")
        .setAttribute("style", "overflow:hidden;padding-right:15px");
    },
    /*弹出对话框*/
    getMoney(item) {
      this.modal1 = true;
      this.item01 = item;
      this.ref = item.ref;
      this.profile = item.p;
      this.VRImg = item.VRImg;
    },
    /*刚进页面的立即购买*/
    getMoney01(item) {
      this.goBuy(item);
    },
    /*弹出框里面立即购买*/
    goBuyGo() {
      this.modal1 = false;
      this.goBuy(this.item01);
      document.querySelector("body").setAttribute("style", "overflow:auto");
    },
    /*购买*/
    goBuy(item) {
      sessionStorage.setItem("title", item.title);
      sessionStorage.setItem("belong", item.belong);
      sessionStorage.setItem("path", item.path);
      sessionStorage.setItem("money", item.money);
      sessionStorage.setItem("ref", item.ref);
      sessionStorage.setItem("photoUrl1", item.photoUrl1);
      sessionStorage.setItem("classify", JSON.stringify(item.classify));
      this.$router.push({
        path: "/home/buyGo",
      });
    },
  },
};
</script>
<style>
.modal_div .ivu-modal-header p,
.modal_div .ivu-modal-header-inner {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

/*面包屑*/
.col_bread .ivu-breadcrumb {
  font-size: 16px;
}
</style>
<style scoped>
/*弹出框字体*/
.header_div {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

.font_size {
  font-size: 19px;
}

.buy_col01 {
  width: 270px;
  background: #f7f7f7;
  text-align: center;
  cursor: pointer;
  margin: 14px 0px 0 22px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.buy_col01:hover {
  box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.2);
}

.buy_col01 .sp:hover {
  color: red;
}

.buy_rule {
  width: 270px;
  height: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.buy_rule img {
  width: 210px;
  height: 210px;
}

.sp {
  font-size: 14px;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/Buy/VR.vue